import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { DatePicker, Select } from 'hljd'
import { SearchBar } from 'hljd'
import { lastSevenDays, lastThirtyDays } from '@util'
import { TRADE_TYPE } from '@components/ExperienceShop/constant'

const RangePicker = DatePicker.RangePicker
const Item = SearchBar.Item
const Option = Select.Option

export default class extends Component {
  static defaultProps = {
    showTradeType: true
  }

  render() {
    const { store, showTradeType, timeKey, extra } = this.props

    return (
      <SearchBar store={store} extra={extra}>
        <Item label="时间" name={timeKey}>
          <RangePicker />
        </Item>

        <Form.Item style={{ marginRight: 10 }}>
          <div
            style={{
              display: 'flex',
              justifyItems: 'center',
              alignItems: 'center',
              height: 32
            }}
          >
            <a
              style={{
                marginRight: 10
              }}
              onClick={() => {
                store.$searchBar.setFieldsValue({
                  [timeKey]: lastSevenDays()
                })
              }}
            >
              最近7天
            </a>
            <a
              onClick={() => {
                store.$searchBar.setFieldsValue({
                  [timeKey]: lastThirtyDays()
                })
              }}
            >
              最近30天
            </a>
          </div>
        </Form.Item>

        {showTradeType && (
          <Item label="交易类型" name="type">
            <Select placeholder="请选择" style={{ width: 200 }}>
              <Option value="">全部</Option>
              {Object.keys(TRADE_TYPE).map(key => {
                return (
                  <Option key={key} value={key}>
                    {TRADE_TYPE[key]}
                  </Option>
                )
              })}
            </Select>
          </Item>
        )}
      </SearchBar>
    )
  }
}
